import React from 'react';
import * as Sentry from '@sentry/react';
import DefaultError from '../../../Assets/Defalut_image.png';
import NetWork from '../../../Assets/Error-404.png';
import AuthError from '../../../Assets/ERROR-401.jpg';
import FetchError from '../../../Assets/Error-500.gif';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorCode: null,
      isOffline: !navigator.onLine, // Initial offline state
    };
  }

  

  componentDidMount() {
    // Listen for network status changes
    window.addEventListener('offline', this.handleOffline);
    window.addEventListener('online', this.handleOnline);
  }

  componentWillUnmount() {
    // Clean up listeners
    window.removeEventListener('offline', this.handleOffline);
    window.removeEventListener('online', this.handleOnline);
  }

  handleOffline = () => {
    this.setState({ isOffline: true });
  };

  handleOnline = () => {
    this.setState({ isOffline: false });
  };

  static getDerivedStateFromError(error) {
    // Capture error information
    const errorCode = error?.response?.status || null; // Check if error has a status code
   
    return { hasError: true, error, errorCode };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
    Sentry.captureException(error); // Send error details to Sentry
  }

  renderFallback() {
    const { isOffline, error, errorCode,  } = this.state;
 
    let imageSrc = DefaultError;
    let message = 'Oops! Something went wrong.';
    let statusMessage = '';

    const objectId = localStorage.getItem('objectId'); // Check for token

    // Redirect to login if no token and not a network error
    if (!objectId && !isOffline) {
      window.location.href = '/login';
      return null; // prevent rendering fallback UI
    }

    if (isOffline) {
      imageSrc = NetWork;
      message = 'No Internet Connection';
      statusMessage = 'Please check your network and try again.';
    } else if (errorCode === 401 ) {
      imageSrc = AuthError;
      message = 'Unauthorized';
      statusMessage = 'You are not authorized to access this page.';
    } else if (errorCode === 500) {
      imageSrc = FetchError;
      message = 'Server Error';
      statusMessage = 'The server encountered an issue. Please try again later.';
    } else if (error?.message?.includes('Network')) {
      imageSrc = NetWork;
      message = 'Network Error';
      statusMessage = 'There seems to be a problem with your connection.';
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          // border: "1px solid red",
          textAlign: "center",
          padding: "2rem",
        }}
      >
        <img
          src={imageSrc}
          alt="Error occurred"
          style={{ maxWidth: "40%", height: "auto", marginBottom: "1rem" }}
        />
        <h1>{message}</h1>
        <p>{statusMessage || error?.message || "An unexpected error occurred."}</p>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: "10px 20px",
            fontSize: "16px",
            background: "#007BFF",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            marginTop: "1rem",
          }}
        >
          Reload
        </button>
      </div>
    );
  }

  render() {
    if (this.state.hasError || this.state.isOffline) {
      return this.renderFallback();
    }

    return (
      <Sentry.ErrorBoundary
        fallback={({ error }) => this.renderFallback(error)}
        onError={(error, componentStack) => {
          // Log error details to Sentry
          Sentry.captureException(error);
          console.error('Error caught by Sentry.ErrorBoundary:', error, componentStack);
        }}
      >
        {this.props.children}
      </Sentry.ErrorBoundary>
    );
  }
}

export default ErrorBoundary;